import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPosts } from '../../actions/postActions';
import Spinner from '../common/Spinner/Spinner';
import Posts from './Posts';


class PostsContainer extends Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    count: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    fetching: PropTypes.bool.isRequired,
    getPosts: PropTypes.func.isRequired
  };

  state = {
    page: 1,
    limit: 9
  };

  componentDidMount() {
    this.props.getPosts(this.state.limit, this.state.page);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.props.getPosts(this.state.limit, this.state.page);
    }
  }

  setPage = (page) => {
    this.setState({ page });
  }

  render() {
    const { posts, count, fetching } = this.props;
    const pages = Math.ceil(count / this.state.limit);

    if (fetching) {
      return <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />;
    } else {
      return (
        <Posts
          posts={posts}
          pages={pages}
          page={this.state.page}
          setPage={this.setPage}
        />
      );
    }

  }
}


const mapStateToProps = (state) => ({
  posts: state.posts.all,
  count: state.posts.count,
  fetching: state.posts.fetching
});

const mapDispatchToProps = {
  getPosts
};

export default connect(mapStateToProps, mapDispatchToProps)(PostsContainer);



// WEBPACK FOOTER //
// ./src/components/Posts/PostsContainer.js